Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

exports.CUSTOM_EVENTS = void 0;
(function (CUSTOM_EVENTS) {
    CUSTOM_EVENTS["CHAT_STATUS_CHANGED"] = "chat-status-changed";
    CUSTOM_EVENTS["CHAT_REQUEST"] = "chat-request";
})(exports.CUSTOM_EVENTS || (exports.CUSTOM_EVENTS = {}));
